import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ContentChild, EventEmitter, Input, Output } from '@angular/core';
import { DrawerBackdropComponent } from './drawer-backdrop.component';
import { DrawerContentDirective } from './drawer-content.directive';
import { DrawerTriggerDirective } from './drawer-trigger.directive';

@Component({
  selector: 'mpro-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '0'
      })),
      state('closed', style({})),
      transition('open => closed', [
        animate('0.3s ease-in-out')
      ]),
      transition(':leave', [
        animate('0.3s ease-in-out')
      ]),
      transition('closed => open', [
        animate('0.3s ease-in-out')
      ]),
      transition(':enter', [
        animate('0.3s ease-in-out')
      ]),
    ]),
  ]
})
export class DrawerComponent implements AfterViewInit {
  @ContentChild(DrawerTriggerDirective)
  public triggerDirective: DrawerTriggerDirective;
  @ContentChild(DrawerContentDirective)
  public contentDirective: DrawerContentDirective;
  @ContentChild(DrawerBackdropComponent)
  public backdrop: DrawerBackdropComponent;
  @Output() public onCancel: EventEmitter<void> = new EventEmitter();
  @Input() public hideCancel: boolean = false;
  @Input() public isOpen = false;
  @Output() public isOpenChange: EventEmitter<boolean> = new EventEmitter();
  @Output() public onOpenDone: EventEmitter<void> = new EventEmitter();

  public get context(): { [key: string]: any } {
    return {
      isOpen: this.isOpen,
      toggle: () => this.toggle()
    }
  }

  public ngAfterViewInit(): void {
    if (this.isOpen) {
      setTimeout(() => this.contentDirective.show(this.context));
    }
  }

  public captureDoneEvent(event: AnimationEvent) {
    if (event.toState === 'open') {
      this.onOpenDone.emit();
    }
  }

  toggle() {
    if (!this.contentDirective.render) {
      this.contentDirective.show(this.context);
    } else {
      this.contentDirective.hide();
    }
    this.isOpen = !this.isOpen;
    this.isOpenChange.emit(this.isOpen);
    if (!this.isOpen) {
      this.onCancel.emit();
    }
  }
}